import type { MissionCapacity } from '@/types/mission'

type MissionCapacitySource = {
  min?: number | null
  max?: number | null
  _capacity?: MissionCapacity
}

export const missionHasParticipantRestriction = (
  mission: MissionCapacitySource
): boolean => {
  const capacity = mission._capacity

  const hasMin =
    (typeof capacity?.min_participants === 'number' &&
      capacity.min_participants > 0) ||
    (typeof mission.min === 'number' && mission.min > 0)

  const hasMax =
    (typeof capacity?.max_participants === 'number' &&
      capacity.max_participants > 0) ||
    (typeof mission.max === 'number' && mission.max > 0)

  return hasMin || hasMax
}

/** Exibe contagem só com restrição de vagas/mínimo e total > 0. */
export const getMissionParticipantsDisplay = (
  mission: MissionCapacitySource
): number | null => {
  const total = mission._capacity?.total_participants

  if (!missionHasParticipantRestriction(mission)) return null
  if (typeof total !== 'number' || total <= 0) return null

  return total
}
